export const ONLY_ALPHANUMERIC_REGEX = /^[0-9a-zA-Z]$/;
export const ONLY_NUMERIC_REGEX = /^[0-9]$/;
